import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'

import pic06 from '../assets/images/pic06.jpg'

const Cupcakes = (props) => (
    <Layout>
        <Helmet>
            <title>Cupcakes</title>
            <meta name="description" content="cupcakes" />
            <html lang="en"/>
        </Helmet>

        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <header className="major">
                        <h1>Cupcakes</h1>
                    </header>
                    <div className="grid-wrapper">
                        <span className="image fit col-6"><img src={pic06} alt="Cupcakes" /></span>
                        <p className="col-6">A cupcake is a small cake baked in a cup-shaped foil or paper container and typically iced.</p>
                    </div>
                </div>
            </section>
        </div>

    </Layout>
)

export default Cupcakes